
// import { createRef, useEffect, useState } from "react";
import { useEffect, useState } from "react";
import Slide1 from "../../../../assets/images/carousel/slide-1.png" ;
import Slide2 from "../../../../assets/images/carousel/slide-2.png" ;
import Slide3 from "../../../../assets/images/carousel/slide-3.png" ;
import Slide4 from "../../../../assets/images/carousel/slide-4.png" ;

import {Carousel as BSCarousel} from "bootstrap" ;

import "./carousel.scss" ;
import { Link } from "react-router-dom";
import { CHOOSE_PLAN_ROUTE } from "../../../../routes";

const Carousel = ({currentStep,setCurrentStep}) => {


    const [carouselElement,setCarouselElement] = useState(null) ;
    // const [carousel,setCarousel] = useState(null) ;

    // useEffect(()=>{
    //     if(carouselElement != null){
    //         const BSCarouselElement = new BSCarousel(carouselElement) ;
    //         carouselElement.addEventListener('slide.bs.carousel', function (e) {
    //             setCurrentStep(e.to)
    //         })
    //         setCarousel(BSCarouselElement)
    //     }
    // },[carouselElement,setCurrentStep])

    // useEffect(()=>{
    //     carousel && carousel.to(currentStep);
    // },[currentStep,carousel])

    const slideImageSize = "100%" ;


    useEffect(() => {
        if(carouselElement){
            carouselElement.to(currentStep);
        }
    },[currentStep,carouselElement])

    useEffect(()=>{
        function switchStep(e){
            setCurrentStep(e.to);
        }
        if(carouselElement){
            //console.log("Event Attached");
            carouselElement._element.addEventListener("slide.bs.carousel",switchStep);
        }
        return () => {
            if(carouselElement ){
                //console.log("Event Detached");
                carouselElement._element.removeEventListener("slide.bs.carousel",switchStep);
            }
        }
    },[carouselElement,setCurrentStep])

    useEffect(()=>{
        let carouselDOM = document.querySelector("#how-it-works-carousel") ;
        setCarouselElement(new BSCarousel(carouselDOM))
    },[])



    return ( 
        <div id="how-it-works-carousel" data-bs-interval="false" className="carousel slide carousel-fade bg-gray-200">

            <div className="carousel-indicators dotContainer">
                <button className="dot active" type="button" data-bs-target="#how-it-works-carousel" data-bs-slide-to="0" aria-label="Slide 1"></button>
                <button className="dot"        type="button" data-bs-target="#how-it-works-carousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button className="dot"        type="button" data-bs-target="#how-it-works-carousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
                <button className="dot"        type="button" data-bs-target="#how-it-works-carousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
            </div>

            <div className="carousel-inner">
                <div className="carousel-item active">
                    <div className="h-100 d-flex justify-content-center align-items-center">
                        <Link to={CHOOSE_PLAN_ROUTE}>
                            <img src={Slide1} className="d-block img-fluid" style={{width:slideImageSize}}  alt=""></img>
                        </Link>
                    </div>
                </div>
                <div className="carousel-item">
                    <div className="d-flex justify-content-center align-items-center">
                        <img src={Slide2} className="d-block" style={{width:slideImageSize}} alt=""></img>
                    </div>
                </div>
                <div className="carousel-item">
                    <div className="d-flex justify-content-center align-items-center">
                        <img src={Slide3} className="d-block img-fluid" style={{width:slideImageSize}} alt=""></img>
                    </div>                    
                </div>
                <div className="carousel-item">
                    <div className="d-flex justify-content-center align-items-center">
                        <img src={Slide4} className="d-block img-fluid" style={{width:slideImageSize}} alt=""></img>
                    </div>                    
                </div>
            </div>
        </div>
    );
}
 
export default Carousel;